import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isNil } from 'lodash-es';
import { Store, select } from '@ngrx/store';
import { RootState } from '../../../root-store/root.state';
import { SearchPageConfigurationService } from '../../../search-page/search-page-configuration.service';
import { SearchFormType } from '../../../search-page/search-page-type.enum';
import { EstensaColDef } from '../../../search-page/search-param.model';
import { SeSideComponentBase } from '../se-side-components-models';
import { selectSeSearchSelectedItems } from '../../../search-page/redux/search-page.selectors';
import { DetailItem } from './se-side-details-models';
import { GridUtilitiesService } from '../../../services/grid-utilities.service';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'se-side-details',
    templateUrl: './se-side-details.component.html',
    styleUrls: ['./se-side-details.component.scss'],
})
export class SeSideDetailsComponent extends SeSideComponentBase implements OnInit, OnDestroy {
    private feedbackMessage: Map<number, string> = new Map<number, string>();
    private readonly unsubscribe$: Subject<void> = new Subject();
    private selectedItems$: Observable<any>;

    colDefs: EstensaColDef[] = [];
    details: Array<DetailItem> = [];

    koMessage: string = '';
    showDetailsNote: boolean = true;

    constructor(
        private translate: TranslateService,
        readonly searchPageConfigurationService: SearchPageConfigurationService,
        readonly store: Store<RootState>,
        readonly gridUtils: GridUtilitiesService,
    ) {
        super();
        this.feedbackMessage.set(-1, 'NoDetail');
        this.feedbackMessage.set(0, 'NoSelection');
        this.feedbackMessage.set(1, '');
        this.feedbackMessage.set(2, 'MultipleSelection');
    }

    ngOnInit() {
        this.initComponent();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private retrieveDetails(formType: SearchFormType, idPropertyName: string) {
        this.store
            .pipe(select(selectSeSearchSelectedItems(formType, idPropertyName)), takeUntil(this.unsubscribe$))
            .subscribe((response) => this.getDetails(response, this.gridUtils));

        /*task 96963 aggancio osservabile sul cambio primary colonna da rotellina*/
        this.searchPageConfigurationService.toggleColumnPrimary$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(({ colId, primary }) => {
                this.colDefs.forEach((det) => {
                    if (det.colId == colId) {
                        det.estensaDetails.primary = primary;
                    }
                });
            });

        this.searchPageConfigurationService.toggleColumnVisibility$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(({ colId, isVisible }) => {
                this.details.forEach((det: DetailItem) => {
                    if (det.estensaColDef.colId == colId)
                        det.estensaColDef.hide = !isVisible;
                });
            });
    }

    private initComponent() {
        this.store
            .select((state) => state.seSideNav.details)
            .subscribe((detailsConfig) => {
                this.initColDefs(detailsConfig.searchForm);
                this.retrieveDetails(detailsConfig.searchForm, detailsConfig.idColumnName);
            });
    }

    private initColDefs (formType : SearchFormType) {
        this.colDefs = this.searchPageConfigurationService.getAllColumnDefs(formType);
        if (!this.colDefsFound()) {
            console.error('No ColDefs found in page');
            return;
        }
        this.koMessage = !this.colDefs.length
            ? (this.feedbackMessage.get(-1) as string)
            : (this.feedbackMessage.get(0) as string);
    }

    private colDefsFound(): boolean {
        return !isNil(this.colDefs) && this.colDefs.length > 0;
    }

    private getDetails(data: any[], gridUtils: GridUtilitiesService) {
        this.details = [];
        if (data.length !== 1) {
            this.koMessage = this.feedbackMessage.get(data.length === 0 ? 0 : 2);
            return;
        }
        this.koMessage = this.feedbackMessage.get(1);
        this.colDefs.forEach((colDef : EstensaColDef) => {
            this.details.push(new DetailItem(colDef, data[0]));
        });
    }
}
